import { Tooltip } from '@material-ui/core';
import { StyledCell } from '../Table.style';
import styled from 'styled-components';
import useToast from 'components/hooks/useToast';
import { copyToClipboard } from 'common/utils/clipboard.utils';

const StyledCommitShaCell = styled(StyledCell)`
  & .commit-sha {
    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }
  }
`;
const MAX_CHARACTERS = 10;

const CommitShaCell = ({ commitSha = '' }) => {
  const toggleSnackBar = useToast();
  const startSha = commitSha.substring(0, MAX_CHARACTERS / 2);
  const endSha = commitSha.substring(
    commitSha.length - MAX_CHARACTERS / 2,
    commitSha.length
  );
  const shortCommitSha = `${startSha}.....${endSha}`;
  const isTooLong = commitSha.length > MAX_CHARACTERS;

  return (
    <StyledCommitShaCell>
      <Tooltip title='Copy to Clipboard' placement='top'>
        <div
          className='commit-sha'
          onClick={() => copyToClipboard({ toggleSnackBar, value: commitSha })}
        >
          {isTooLong ? shortCommitSha : commitSha}
        </div>
      </Tooltip>
    </StyledCommitShaCell>
  );
};

export default CommitShaCell;
